












import Vue from 'vue'

export default Vue.extend({
  name: 'RenderContent',
  props: {
    content: {
      type: Array,
    },
  },
  data: () => ({
    mapping: {
      'vuestorefront:accordion': 'Accordion',
      'vuestorefront:banner': 'Banner',
      'vuestorefront:CommonBanner': 'Banner',
      'vuestorefront:calltoaction': 'CallToAction',
      'vuestorefront:MoominHeroBanner': 'Hero',
      'vuestorefront:heading': 'Heading',
      'vuestorefront:productcard': 'ProductCard',
      'vuestorefront:list': 'List',
      'vuestorefront:link': 'Link',
      'vuestorefront:tabs': 'Tabs',
      'vuestorefront:carousel': 'Carousel',
      'vuestorefront:gallery': 'Gallery',
      'vuestorefront:Grid': 'Grid',
      'vuestorefront:button': 'Button',
      'vuestorefront:MArticleSlider': 'ArticleSlider',
      'vuestorefront:MArticleList': 'ArticleList',
      'vuestorefront:moominCardHorizontal': 'CardHorizontal',
      'vuestorefront:moominProductSlider': 'ProductSlider',
      'vuestorefront:moominProductList': 'MiniProductList',
      'vuestorefront:NewsletterSubscribe': 'MoominNewsletterSection',
      'vuestorefront:exploreCharacters': 'ExploreCharacters',
      'vuestorefront:categoryCollection': 'MoominCategoryCardCarousel',
      'vuestorefront:benefitsBar': 'MoominBenefitBar',
      'vuestorefront:CategoryAndCollectionProductSlider':'CategoryProductSlider',
      'vuestorefront:CollectionsMappings': 'MoominCategoryCardGrid',
      'vuestorefront:MoominHeroImage': 'MoominFullWidthImage',
      'vuestorefront:MoominContent': 'MoominRichTextContent',
      'vuestorefront:moominquote': 'Quote',
      'vuestorefront:SearchResults': 'SearchResults',
      'vuestorefront:ProductListing': 'MoominProductListing',
      'vuestorefront:MoominUserRegistrationForm': 'MoominRegisterForm',
      'vuestorefront:MoominWelcomeBlock': 'MoominWelcomeBlock',
      'vuestorefront:MoominMemberBenefits': 'MoominMemberBenefitsBox',
      'vuestorefront:MoominLoginForm': 'MoominLoginForm',
      'vuestorefront:MoominForgotPasswordForm': 'MoominForgotPasswordForm',
      'vuestorefront:MoominCreatePasswordForm': 'MoominCreatePassword',
      'vuestorefront:ProductDetails': 'MoominProductDetails',
      'vuestorefront:MoominCart': 'MoominCartPreview',
      'vuestorefront:moominMyAccountNav': 'MoominMyAccountNav',
      'vuestorefront:MoominMyAccountPersonalDetailsSubNav': 'MoominMyAccountSubNav',
      'vuestorefront:MoominMyAccountPurchaseSubNav': 'MoominMyAccountOrderHistoryContainer',
      'vuestorefront:MoominCookiePolicy': 'MoominCookiePolicy',
      'vuestorefront:MoominCheckout': 'MoominCheckoutPage',
      'vuestorefront:MoominPaymentOngoing': 'MoominPaymentOngoing',
      'vuestorefront:MoominOrderConfirmation': 'MoominOrderConfirmationPage',
      'vuestorefront:MoominMyAccountShippingBillingSubNav': 'MoominMyAccountAddressBookContainer',
      'vuestorefront:ContactUs': 'MoominContactForm',
      'vuestorefront:MoominHeroVideoNew': 'MoominVideoHero',
      'vuestorefront:MoominSocialMediaSlider': 'MoominSocialMedia',
      'vuestorefront:SpotlightWaveDisplay': 'MoominSpotlightWaveDisplay',
      'vuestorefront:counter': 'MoominCountdown',
    },
  }),
})
